// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"606":"ce35deb1","889":"90974f2c","987":"32069394"}[chunkId] + ".css";
};